import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "d08db5f5-a41a-4985-818f-57c77f308c31",
  publicId: "30",
  name: "Playback systems",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
